import React from 'react';
import ReferencesFilter from '@/components/References/ReferencesFilter';

interface FilterSectionProps {
  selectedTags: string[];
  onTagToggle: (tag: string) => void;
  onClearFilters: () => void;
  searchTerm?: string;
  onSearchChange?: (term: string) => void;
}

const FilterSection = ({ 
  selectedTags, 
  onTagToggle, 
  onClearFilters,
  searchTerm,
  onSearchChange
}: FilterSectionProps) => {
  return (
    <ReferencesFilter 
      selectedTags={selectedTags} 
      onTagToggle={onTagToggle} 
      onClearFilters={onClearFilters}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
    />
  );
};

export default FilterSection; 